export default __webpack_public_path__ + "static/media/spin-wheel-hit.d87ff9a6.wav";